// Shared display helpers for AI draft items (decks + cards).
// Shapes may vary while the backend is being built — render defensively.

export const getAiItemId = (item) => item?._id ?? item?.id;

export const getAiItemTitle = (item) => {
  const id = getAiItemId(item);
  return (
    item?.title ||
    item?.name ||
    item?.meaning?.character ||
    item?.character ||
    item?.word ||
    (id !== undefined && id !== null ? `#${id}` : "—")
  );
};

export const getAiItemSubtitle = (item, type) => {
  if (type === "card") {
    const pinyin = item?.meaning?.pinyin || item?.pinyin;
    const trans = item?.meaning?.trans || item?.translation || item?.trans;
    return [pinyin, trans].filter(Boolean).join(" · ");
  }
  const level = item?.level;
  const category =
    typeof item?.category === "string" ? item?.category : item?.category?.name || item?.category?.title;
  return [level, category].filter(Boolean).join(" · ");
};

export const isAiItemPremium = (item) => !!item?.premium?.active;
